import { useLang, useSeo } from '@/i18n/LanguageContext';
import PageHero from '@/components/PageHero';
import SectionHead from '@/components/SectionHead';
import CtaBand from '@/components/CtaBand';
import Icon from '@/components/Icon';
import { Reveal } from '@/components/Reveal';

export default function Solutions() {
  const { content } = useLang();
  useSeo(`${content.solutions.title} | Rodotrack`, content.solutions.subtitle);
  const c = content;

  return (
    <>
      <PageHero badge={c.solutions.eyebrow} title={c.solutions.title} subtitle={c.solutions.subtitle} />
      <section className="py-16 lg:py-24" data-testid="solutions-grid">
        <div className="container-x grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {c.solutions.items.map((s, i) => (
            <Reveal key={i} delay={(i % 4) * 0.06}>
              <article data-testid={`solutions-item-${i}`} className="group h-full rounded-2xl border border-brand-line bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:border-brand-blue/50 hover:shadow-[0_24px_48px_-24px_rgba(30,159,224,0.35)]">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-ice text-brand-blue transition-colors group-hover:bg-brand-blue group-hover:text-white">
                  <Icon name={s.icon} className="h-6 w-6" />
                </span>
                <h2 className="mt-5 font-display text-lg font-bold text-brand-navy">{s.title}</h2>
                <p className="mt-2 text-sm leading-relaxed text-brand-muted">{s.desc}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </section>
      <section className="pb-20 lg:pb-28" data-testid="solutions-compliance">
        <div className="container-x">
          <Reveal>
            <div className="grain relative overflow-hidden rounded-3xl bg-brand-navy px-8 py-10 lg:px-12">
              <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-brand-blue/25 blur-3xl" />
              <h3 className="relative font-display text-xl font-bold text-white sm:text-2xl">{c.compliance.title}</h3>
              <div className="relative mt-6 flex flex-wrap gap-2.5">
                {c.compliance.items.map((item, i) => (
                  <span key={i} className="rounded-full border border-white/15 bg-white/5 px-4 py-2 font-mono text-[12px] font-medium text-brand-cyan">
                    {item}
                  </span>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </section>
      <div className="-mt-10"><CtaBand /></div>
    </>
  );
}